import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React from 'react';
import Form from '../../form';

var FormModal = function FormModal(_ref) {
  var onClose = _ref.onClose,
      _onSuccess = _ref.onSuccess,
      rest = _objectWithoutProperties(_ref, ["onClose", "onSuccess"]);

  return React.createElement(Form.Dialog, Object.assign({
    onSuccess: function onSuccess() {
      _onSuccess.apply(void 0, arguments);

      onClose();
    },
    onCancel: onClose
  }, rest));
};

export default FormModal;